module.exports = __webpack_public_path__ + "static/media/moloch__logo--simple--red.128f5baa.png";